import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createAsyncMetaSelectors } from '@mews/framework';
import { moduleSelector } from '../module';

const getMeta = flow(moduleSelector, get('meta'));

export const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);
